import {
  COOKIE_CONSENT_COOKIE_NAME,
  type CookieConsentStatus,
} from "@/app/store/cookieConsentSlice";

/**
 * Reads the visitor's cookie-banner choice straight from the consent cookie.
 *
 * The Redux slice is the reactive source for components; this helper exists for code that
 * runs outside React (event senders, link builders) and must see the choice made a moment
 * ago, before any re-render.
 *
 * @returns `accepted`, `rejected`, or `unknown` (no choice yet, or on the server).
 */
export function readConsentStatus(): CookieConsentStatus {
  if (typeof document === "undefined") return "unknown";
  const prefix = `${COOKIE_CONSENT_COOKIE_NAME}=`;
  const row = document.cookie.split("; ").find((r) => r.startsWith(prefix));
  const value = row?.slice(prefix.length);
  return value === "accepted" || value === "rejected" ? value : "unknown";
}

/**
 * Whether the visitor accepted measurement cookies. Every identified event (session UUID,
 * sessionStorage) is gated on this.
 */
export function hasTrackingConsent(): boolean {
  return readConsentStatus() === "accepted";
}
